// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";


const UsersLogoutApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/users/logout";

    // API実行
    const ExecUsersLogoutApi = async () => {
        // 必要なリクエストなし

        let response = null;
        let error = null;
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        return { response, error };
    };

    return ExecUsersLogoutApi;
};

export default UsersLogoutApi;